import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ShoppingBag, CalendarHeart, Trophy, Wind, BookOpen, Compass } from 'lucide-react';
import { wellnessRecommendations } from '../api';

const TYPE = {
  product: { icon: ShoppingBag, label: 'Product' },
  service: { icon: CalendarHeart, label: 'Service' },
  program: { icon: Trophy, label: 'Program' },
  practice: { icon: Wind, label: 'Practice' },
  prompt: { icon: BookOpen, label: 'Journal Prompt' },
  discovery: { icon: Compass, label: 'Discovery' },
};

export const RecoStrip = () => {
  const [items, setItems] = useState(null);
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    wellnessRecommendations().then((r) => {
      const mixed = [];
      (r.products || []).forEach((p) => mixed.push({ type: 'product', title: p.name, reason: p.reason, to: `/product/${p.id}`, image: p.image }));
      (r.services || []).forEach((s) => mixed.push({ type: 'service', title: s.name, reason: s.reason, to: '/book' }));
      (r.programs || []).forEach((p) => mixed.push({ type: 'program', title: p.title, reason: p.reason, to: '/programs' }));
      (r.practices || []).forEach((p) => mixed.push({ type: 'practice', title: 'Try this practice', reason: p, to: '/account' }));
      (r.prompts || []).forEach((p) => mixed.push({ type: 'prompt', title: 'Reflect on this', reason: p, to: '/account' }));
      (r.next_quizzes || []).forEach((q) => mixed.push({ type: 'discovery', title: q.title, reason: 'A discovery to deepen your profile', to: '/discover' }));
      // interleave by type so the strip is varied
      const byType = {}; mixed.forEach((m) => { (byType[m.type] = byType[m.type] || []).push(m); });
      const order = ['product', 'discovery', 'service', 'practice', 'program', 'prompt'];
      const woven = []; let added = true;
      while (added) { added = false; order.forEach((t) => { const a = byType[t]; if (a && a.length) { woven.push(a.shift()); added = true; } }); }
      setItems(woven);
    }).catch(() => setItems([]));
  }, []);

  useEffect(() => {
    if (!items || items.length <= 3) return;
    const id = setInterval(() => setOffset((o) => (o + 3) % items.length), 8000);
    return () => clearInterval(id);
  }, [items]);

  if (!items) return null;
  if (items.length === 0) {
    return (
      <div className="card-glass rounded-2xl p-5 sm:p-6" data-testid="dashboard-recos-empty">
        <h3 className="font-cinzel text-lg text-[#f0d582] mb-1 flex items-center gap-2"><Sparkles className="h-4 w-4" /> Recommended For You</h3>
        <p className="font-cormorant text-[#f5ecd9]/55">Add a few interests or take a Discovery and personalized picks will appear here.</p>
        <Link to="/discover" className="inline-block mt-2 text-[11px] uppercase tracking-widest font-jost text-[#f0d582]">Start a Discovery →</Link>
      </div>
    );
  }
  const visible = items.length <= 3 ? items : [0, 1, 2].map((i) => items[(offset + i) % items.length]);
  return (
    <div className="card-glass rounded-2xl p-5 sm:p-6" data-testid="dashboard-recos">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-cinzel text-lg text-[#f0d582] flex items-center gap-2"><Sparkles className="h-4 w-4" /> Recommended For You</h3>
        <Link to="/account" onClick={() => { const el = document.querySelector('[data-testid="account-tab-wellprofile"]'); el && el.click(); }} className="text-[10px] uppercase tracking-widest font-jost text-[#f5ecd9]/50 hover:text-[#f0d582]">View all</Link>
      </div>
      <div className="grid sm:grid-cols-3 gap-3" data-testid="dashboard-reco-items">
        {visible.map((it, idx) => {
          const meta = TYPE[it.type] || TYPE.product; const Icon = meta.icon;
          return (
            <Link key={idx} to={it.to} className="rounded-xl p-4 border border-white/8 bg-white/[0.03] hover:border-[#d4af37]/40 transition-all block">
              <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-jost text-[#f0d582]/80"><Icon className="h-3 w-3" /> {meta.label}</span>
              <p className="font-cinzel text-sm text-[#f5ecd9] mt-2 leading-snug">{it.title}</p>
              <p className="font-jost text-[11px] text-[#f5ecd9]/55 mt-1 leading-snug">{it.reason}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default RecoStrip;
